<form #eventForm="ngForm" novalidate>
    <div class="flex items-center justify-center dialog-header ">
        {{pageTitle}} Email Template

        <div class="absolute right-2 flex gap-0 items-center">

            <p-button 
            [disabled]="btnLoading || eventForm.invalid"
            [loading]="btnLoading"
            (click)="handleSaveTemplate(eventForm)" class="outline-none p-5" severity="danger">
                <i class="pi pi-save mr-2"></i> Save

            </p-button>

            <button (click)="handleCloseDialog()" class="outline-none pl-1 pr-5">
                <i class="pi pi-times"></i>
            </button>
        </div>

    </div>

    <div class="dialog-content">
        <div class="modal-body mt-0 px-0 py-3 pt-0" >
            <div class="gap-1 md:gap-5 grid grid-cols-1 md:grid-cols-3">
                <div class="flex-1 flex flex-col gap-2">
                    <label for="templateName">Template Name</label>
                    <input pInputText type="text" class="w-full" placeholder="Template Name" name="templateName"
                        [(ngModel)]="formData.templateName" required #templateName="ngModel" />
                    <div class="errors" *ngIf="templateName.invalid && templateName.touched" severity="error"
                        text="Template Name is required."></div>
                </div>

                <div class="flex-1 flex flex-col gap-2">
                    <label for="templateCategory">Template Category</label>
                    <p-select [options]="categories" placeholder="Select Category" name="templateCategory"
                        [(ngModel)]="formData.templateCategory" required #templateCategory="ngModel"></p-select>
                    <div class="errors" *ngIf="templateCategory.invalid && templateCategory.touched" severity="error"
                        text="Please select a category."></div>
                </div>

                <div class="flex-1 flex flex-col gap-2">
                    <label for="status">Status</label>
                    <p-select [options]="statusOptions" placeholder="Select Status" name="status"
                        [(ngModel)]="formData.status" required #status="ngModel"></p-select>
                    <div class="errors" *ngIf="status.invalid && status.touched" severity="error"
                        text="Please select a status."></div>
                </div>
            </div>

            <div class="flex flex-col gap-3 mt-4">
                <!-- Attachments Section -->
                <div class="border rounded-lg p-4">
                    <div class="flex items-center justify-between mb-3">
                        <label class="font-semibold">Attachments</label>
                        <p-fileUpload 
                            mode="basic" 
                            chooseLabel="Add Attachment" 
                            chooseIcon="pi pi-paperclip"
                            (onSelect)="onFileSelect($event)" 
                            [multiple]="true"
                            [auto]="true"
                            accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                            [maxFileSize]="10485760"
                            class="attachment-upload">
                        </p-fileUpload>
                    </div>
                    
                    <div *ngIf="attachments.length > 0" class="flex flex-wrap gap-3">
                        <div *ngFor="let attachment of attachments; let i = index" 
                             class="relative border rounded-lg p-3 min-w-[150px] max-w-[200px]"
                             [class.opacity-50]="attachment.uploading"
                             [class.pointer-events-none]="attachment.uploading">
                            
                            <!-- Loading Overlay -->
                            <div *ngIf="attachment.uploading" 
                                 class="absolute inset-0 flex items-center justify-center bg-gray-200 bg-opacity-75 rounded-lg z-10">
                                <p-progressSpinner [style]="{width: '30px', height: '30px'}" 
                                                   strokeWidth="4">
                                </p-progressSpinner>
                            </div>
                            
                            <!-- Attachment Content -->
                            <div class="flex items-center gap-2">
                                <i [class]="'pi ' + getFileIcon(attachment.type) + ' text-2xl'"></i>
                                <div class="flex-1 overflow-hidden">
                                    <div class="text-sm font-medium truncate">{{attachment.name}}</div>
                                    <div class="text-xs text-gray-500">{{attachment.type}}</div>
                                </div>
                                <button *ngIf="!attachment.uploading" 
                                        type="button"
                                        (click)="removeAttachment(i)" 
                                        class="text-red-500 hover:text-red-700">
                                    <i class="pi pi-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    <div *ngIf="attachments.length === 0" class="text-sm text-gray-500 text-center py-2">
                        No attachments added
                    </div>
                </div>
            </div>

            <div class="flex gap-5 mt-4">
                <div class="min-w-[230px] overflow-y-auto dynamic-pannel">
                    <p-panel header="Signature">
                        <div *ngFor="let field of signatures"
                            class="flex flex-row items-center border-b border-black py-2 text-sm text-ellipsis overflow-hidden">
                            <div [attr.draggable]="true" style="flex: 1;"
                                (dragstart)="onDragStart2($event, field?.signature)" (dragend)="onDragEnd2($event)"
                                class="cursor-move" [innerHTML]="field?.signature">
                            </div>
                        </div>
                    </p-panel>

                    <br />

                    <p-panel header="Dynamic Fields">
                        <div *ngFor="let field of allLeadFeilds"
                            class="flex flex-row items-center  border-b border-black py-2 text-sm relative">
                            <div [attr.draggable]="true" style="flex: 1;"
                                (dragstart)="onDragStart($event, field?.value)" (dragend)="onDragEnd($event)"
                                class="cursor-move">
                                {{ field?.key }}
                            </div>

                            <div style="cursor: pointer; min-width: 40px;" class="copy-button"
                                (click)="copyToClipboard(field?.value)">
                                Copy
                            </div>
                        </div>
                    </p-panel>
                </div>

                <div class="flex-1 relative h-[70vh] mr-2" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
                    <div *ngIf="isSignatureDraging"
                        class="h-[57px] bg-blue-700 text-white font-semibold flex items-center justify-center rounded-t-lg">
                        Drop your dynamic fields here
                    </div>
                    <div *ngIf="!isSignatureDraging"
                        class="h-[57px] bg-blue-700 text-white font-semibold flex items-center justify-center rounded-t-lg">
                        Create your email template here by dragging elemnts from the right side.
                    </div>
                    <div *ngIf="isLoaded">
                        <email-editor style="height: 68vh;" (dragover)="onDragOver($event)" (drop)="onDrop($event)"
                            (loaded)="editorLoaded()" (ready)="editorReady()"></email-editor>
                    </div>

                    <div *ngIf="!isLoaded"
                        class="absolute top-0 left-0 w-full h-full bg-white bg-opacity-50 flex items-center justify-center">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                </div>
            </div>
        </div>

    </div>
</form>